<template>
  <div class="reset-password" :class="classes">
    <container>
      <header-group heading="Opret adgangskode" subheading="Indtast mail og adgangskode"></header-group>
      <validator name="resetPassword">
        <form novalidate>
          <div class="input-group">
            <div class="field">
              <label for="name">Mail</label>
              <input v-model="mail" v-validate:email="['required', 'email']" v-on:keyup.enter="submit" type="text">
            </div>
          </div>
          <div class="input-group">
           <div class="field">
              <label for="name">Adgangskode</label>
              <input v-model="password" v-validate:password="{required: true, minlength: 6}" v-on:keyup.enter="submit" type="password">
            </div>
            <div class="field">
              <label for="name">Adgangskode</label>
              <input v-model="passwordConfirmation" v-validate:password-confirmation="{required: true, match: matchPassword}" v-on:keyup.enter="submit" type="password">
            </div>
          </div>
           <!-- Errors -->
          <div class="errors">
            <p v-if="$resetPassword.email.required">Mail krævet</p>
            <p v-if="$resetPassword.email.email">Gyldig mail krævet</p>
            <p v-if="$resetPassword.password.minlength">Adgangskode skal være på minimum 6 karakterer</p>
            <p v-if="!matchPassword">Adgangskoder matcher ikke</p>
          </div>
          <div class="button" v-if="valid" @click="submit">Opret adgangskode</div>
        </form>
      </validator>
    </container>
  </div>
</template>

<script>
import view from 'src/mixins/view'
import HeaderGroup from 'components/HeaderGroup'
import { http } from 'api/resources'

export default {
  name: 'ResetPassword',
  mixins: [view],
  components: {
    HeaderGroup
  },
  data () {
    return {
      mail: '',
      password: '',
      passwordConfirmation: '',
      submitting: false
    }
  },
  computed: {
    matchPassword () {
      return this.password === this.passwordConfirmation
    },
    valid () {
      return this.$resetPassword.valid && this.matchPassword
    },
    token () {
      return this.$route.params.token
    },
    response () {
      return {
        email: this.mail,
        password: this.password,
        password_confirmation: this.passwordConfirmation
      }
    },
    classes () {
      return {
        'inactive': this.submitting
      }
    }
  },
  methods: {
    submit () {
      if (!this.valid) {
        alert('Felterne er ikke udfyldt tilstrækkeligt')
        return
      }
      this.submitting = true
      http.put(`me/password/${this.token}`, JSON.stringify(this.response))
      .then(response => {
        console.log(response)
        this.submitting = false
        if (response.ok) {
          this.$router.go({name: 'login'})
        } else {
          this.onError(response)
        }
      })
      .catch(this.onError)
    },
    onError (error) {
      this.submitting = false
      alert(JSON.parse(error.body).message)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/boilerplate';

.reset-password {
  &.inactive {
    opacity: 0.25!important;
    pointer-events: none;
  }
}
.button {
  cursor: pointer;
  padding: 1.5rem 1.4rem;
  background: #eee;
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// ResetPassword.vue?633c9d9a